// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#validation-container {
  width: 100vw;
  height: 100vh;
  background-image: url('fondo-gente.png');
  background-size: cover;
  background-position: center center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/validation/validation.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,wCAAA;EACA,sBAAA;EACA,kCAAA;AACF","sourcesContent":["#validation-container {\n  width: 100vw;\n  height: 100vh;\n  background-image: url(\"../../../assets/img/fondo-gente.png\");\n  background-size: cover;\n  background-position: center center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
